var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/Estimation.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { createPredicate } from '../createPredicate'; // eslint-disable-next-line import/no-cycle

import { Id } from '../../Id';
import { Version, VersionData as VersionDataAbstract, VersionDates, VersionStatus } from '../../Version';
import { ApiDomain } from '../../domain';
import { ModelElementStatus } from '../../ForgeViewerRepo';
import { Urn } from '../../Urn';
import { EstimationCalculation } from './EstimationCalculation';
export var Estimation;

(function (_Estimation) {
  var domain = ApiDomain.domain('Estimation', {
    name: "domain",
    sid: "qvl2nt"
  });
  var is = _Estimation.is = createPredicate('Estimation');
  var VersionData = _Estimation.VersionData = t.intersection([VersionDataAbstract.io, t.type({
    estimationVersionStatus: t.union([VersionStatus, t["null"]])
  })]);
  var VersionWithClassifierData = _Estimation.VersionWithClassifierData = t.type({
    estimationVersionData: VersionData,
    classifierId: t.number,
    classifierVersion: t.number
  });
  var Versions = _Estimation.Versions = t.type({
    versions: t.array(VersionData)
  }, 'EstimationVersionData');
  var io = _Estimation.io = t.type({
    type: t.literal('Estimation'),
    id: Id,
    version: Version,
    classifierId: Id,
    classifierVersion: Version,
    parentFolderId: t.union([t["null"], Id]),
    name: t.string,
    calculations: t.readonlyArray(EstimationCalculation.io),
    readOnly: t["boolean"],
    owner: t.union([t["null"], t.string]),
    versionNameOwner: t.union([t["null"], t.string]),
    versionCreatedDate: t.string,
    versionName: t.union([t["null"], t.string]),
    projectUrn: Urn,
    estimationPublishedVersions: t.union([t["null"], t.undefined, t.array(VersionWithClassifierData)])
  });
  var Status = _Estimation.Status = t.union([t.literal('NotStarted'), t.literal('Started'), t.literal('InProgress'), t.literal('Finished'), t.literal('Error')]);
  var EstimationStatus;

  (function (_EstimationStatus) {
    var io = _EstimationStatus.io = t.type({
      id: Id,
      version: Version,
      type: t.literal('EstimationStatus'),
      status: Status
    });
  })(EstimationStatus || (EstimationStatus = _Estimation.EstimationStatus || (_Estimation.EstimationStatus = {})));

  var create = _Estimation.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['name', 'parentFolderId', 'projectUrn']
  });
  var copy = _Estimation.copy = ApiCallService.create({
    name: 'copy',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['name', 'id']
  });
  var rename = _Estimation.rename = ApiCallService.create({
    name: 'rename',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id', 'parentFolderId', 'name']
  });
  var move = _Estimation.move = ApiCallService.create({
    name: 'move',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id', 'parentFolderId']
  });
  var remove = _Estimation.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id']
  });
  var getMostRecent = _Estimation.getMostRecent = ApiCallService.create({
    name: 'getMostRecent',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id']
  });
  var getMostRecentSilent = _Estimation.getMostRecentSilent = ApiCallService.create({
    name: 'getMostRecentSilent',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id']
  });
  var fetch = _Estimation.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['id', 'version']
  });
  var start = _Estimation.start = ApiCallService.create({
    name: 'start',
    parentDomain: domain,
    result: t.unknown,
    getKey: ['estimationId', 'estimationVersion']
  });
  var fetchStatus = _Estimation.fetchStatus = ApiCallService.create({
    name: 'fetchStatus',
    parentDomain: domain,
    result: EstimationStatus.io,
    getKey: ['estimationId', 'estimationVersion']
  });
  var ChangeStatusRes = _Estimation.ChangeStatusRes = t.type({
    classifierId: t.number,
    classifierVersion: t.number,
    estimationVersionData: VersionData
  });
  var changeStatus = _Estimation.changeStatus = ApiCallService.create({
    name: 'changeStatus',
    parentDomain: domain,
    result: ChangeStatusRes,
    getKey: ['estimationId', 'estimationVersion', 'estimationVersionStatus']
  });
  var modelElementEstimationStatus = _Estimation.modelElementEstimationStatus = ApiCallService.create({
    name: 'modelElementEstimationStatus',
    parentDomain: domain,
    result: ModelElementStatus.io,
    getKey: ['estimationId', 'estimationVersion', 'modelId']
  });
  var fetchVersionDates = _Estimation.fetchVersionDates = ApiCallService.create({
    name: 'modelElementEstimationStatus',
    parentDomain: domain,
    result: VersionDates.io,
    getKey: ['estimationId']
  });
  var fetchVersionByDate = _Estimation.fetchVersionByDate = ApiCallService.create({
    name: 'modelElementEstimationStatus',
    parentDomain: domain,
    result: Versions,
    getKey: ['estimationId']
  });
  var renameVersion = _Estimation.renameVersion = ApiCallService.create({
    name: 'renameVersion',
    parentDomain: domain,
    result: VersionData,
    getKey: ['estimationId', 'estimationVersion', 'versionName']
  });
  var removeVersionName = _Estimation.removeVersionName = ApiCallService.create({
    name: 'removeVersionName',
    parentDomain: domain,
    result: VersionData,
    getKey: ['estimationId', 'estimationVersion']
  });
  var fetchNamedVersions = _Estimation.fetchNamedVersions = ApiCallService.create({
    name: 'fetchNamedVersions',
    parentDomain: domain,
    result: Versions,
    getKey: ['estimationId']
  });
  var ImportEstimation = _Estimation.ImportEstimation = ApiCallService.create({
    name: 'ImportEstimation',
    parentDomain: domain,
    result: Estimation.io,
    getKey: ['estimationId', 'estimationVersion', 'sourceEstimationId', 'sourceEstimationVersion', 'sourceProjectUrn']
  });
})(Estimation || (Estimation = {}));